import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";
import ImageCropper from "../crop_image/ImageCropper";
// import "./Galeri.css";

function InfoCompanyAdd() {
    const navigate = useNavigate();

    const fetchData = async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const [formValue, setFormValue] = useState({
        cover: null,
        foto_1: null,
        foto_2: null,
        foto_3: null,
        foto_4: null,
        foto_5: null,
        foto_6: null,
        judul: "",
        penjelasan: "",
    });

    const [preview, setPreview] = useState({
        cover: null,
        foto_1: null,
        foto_2: null,
        foto_3: null,
        foto_4: null,
        foto_5: null,
        foto_6: null,
    });

    const [cropData, setCropData] = useState({
        isOpen: false,
        imageSrc: null,
        imageType: "",
    });

    const [croppedImage, setCroppedImage] = useState(null);

    const openCropper = (file, imageType) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setCropData({
                isOpen: true,
                imageSrc: reader.result,
                imageType,
            });
        };
    };

    const closeCropper = () => {
        setCropData({
            isOpen: false,
            imageSrc: null,
            imageType: "",
        });
        setCroppedImage(null);
    };

    const applyCrop = () => {
        if (croppedImage instanceof Blob) {
            const blobUrl = URL.createObjectURL(croppedImage);
            setFormValue({
                ...formValue,
                [cropData.imageType]: croppedImage,
            });
            setPreview({
                ...preview,
                [cropData.imageType]: blobUrl,
            });
        } else {
            console.error("Cropped image is not a Blob:", croppedImage);
        }
        closeCropper();
    };

    const handleChange = (event) => {
        const { name, value, files } = event.target;
        if (files && files.length > 0) {
            const file = files[0];
            openCropper(file, name);
        } else {
            setFormValue({
                ...formValue,
                [name]: value,
            });
            if (name.startsWith("foto_")) {
                setPreview({
                    ...preview,
                    [name]: null,
                });
            }
        }
    };

    const formatDeskripsi = (text) => {
        return text
            .split("\n")
            .map((penjelasan) => `<p>${penjelasan}</p>`)
            .join("");
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const { cover, foto_1, foto_2, foto_3, foto_4, foto_5, foto_6, penjelasan, judul } =
            formValue;

        // Log nilai untuk debugging
        console.log("Form Values:", formValue);

        // Validasi field yang wajib diisi
        if (!penjelasan || !judul) {
            Swal.fire({
                title: "Error",
                text: "Semua field harus diisi",
                icon: "error",
            });
            return;
        }

        const FormDataInput = new FormData();
        FormDataInput.append("cover", cover);
        FormDataInput.append("foto_1", foto_1);
        FormDataInput.append("foto_2", foto_2);
        FormDataInput.append("foto_3", foto_3);
        FormDataInput.append("foto_4", foto_4);
        FormDataInput.append("foto_5", foto_5);
        FormDataInput.append("foto_6", foto_6);
        FormDataInput.append("penjelasan", formatDeskripsi(penjelasan));
        FormDataInput.append("judul", judul);

        // Log FormData untuk debugging
        for (let pair of FormDataInput.entries()) {
            console.log(pair[0] + ", " + pair[1]);
        }

        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = `Bearer ${token}`;
                    return config;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/career/createCareer`,
                FormDataInput,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            Swal.fire({
                title: "Success",
                text: "Data berhasil ditambahkan",
                icon: "success",
            });
            navigate("/career");
        } catch (error) {
            Swal.fire({
                title: "Error",
                text: "Data gagal ditambahkan",
                icon: "error",
            });
            console.error("Error creating data:", error);
        }
    };

    return (
        <div>
            <Header />
            <Navbar />
            <div className="content-wrapper ">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <Link className="text-decoration-none" to="/">
                                            Administrasi
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active">Berkarir YKBUT</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Tambah Berkarir YKBUT</h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="card-body">
                                                <div className="form-group">
                                                    <label>Judul</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="judul"
                                                        placeholder="Masukkan Judul"
                                                        onChange={handleChange}
                                                        value={formValue.judul}
                                                        style={{ width: "100%" }}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Deskripsi</label>
                                                    <textarea
                                                        className="form-control"
                                                        name="penjelasan"
                                                        placeholder="Masukkan Deskripsi"
                                                        onChange={handleChange}
                                                        rows="4"
                                                        style={{ width: "100%" }}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Cover Foto</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="cover"
                                                        accept="image/*"
                                                        placeholder="Masukkan foto"
                                                        onChange={handleChange}
                                                    />
                                                    {preview.cover && (
                                                        <div className="preview-container-galery">
                                                            <img
                                                                src={preview.cover}
                                                                alt="Preview"
                                                                className="preview-image-galery"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                {[1, 2, 3, 4, 5, 6].map((index) => (
                                                    <div
                                                        className="form-group"
                                                        key={`foto_${index}`}
                                                    >
                                                        <label>Foto {index}</label>
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            name={`foto_${index}`}
                                                            accept="image/*"
                                                            placeholder={`Masukkan foto ${index}`}
                                                            onChange={handleChange}
                                                        />
                                                        {preview[`foto_${index}`] && (
                                                            <div className="preview-container-galery">
                                                                <img
                                                                    src={preview[`foto_${index}`]}
                                                                    alt={`Preview Foto ${index}`}
                                                                    className="preview-image-galery"
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                                <div className="form-group">
                                                    <button type="submit" className="btn btn-info">
                                                        Simpan
                                                    </button>
                                                    <Link to="/career">
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary ml-2"
                                                        >
                                                            Batal
                                                        </button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </form>
                                        {cropData.isOpen && (
                                            <ImageCropper
                                                imageSrc={cropData.imageSrc}
                                                setCroppedImage={setCroppedImage}
                                                onCropComplete={applyCrop}
                                                onClose={closeCropper}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default InfoCompanyAdd;
